module.exports = __webpack_public_path__ + "img/allerton_b5.5454691c.jpg";